const POPIN_STREAK_ACTION: string = 'popinStreakAction';

export const useStreakActionPopin = (waitBeforePlay: number = 500) => {
  const { hasNewStreak, clear, newValue } = useStreakHeader();

  const dialogStreak = useDialogStreak();

  const { onActionHook, complete } = useActionHook(
    POPIN_STREAK_ACTION,
    false,
    -1,
    [],
    waitBeforePlay
  );

  onActionHook(async () => {
    if (!hasNewStreak.value) {
      return complete(false);
    }

    await dialogStreak.open(newValue.value);
    clear();
    complete(true);
  });
};
